import { useLocation } from "react-router";
import { Navigate, Outlet } from "react-router-dom";

// const useAuth = () => {
//   const { user } = useContext(UserContext);
//   return user && user.loggedIn;
// };

const ProtectedRoutes = () => {
  const location = useLocation();
  let token = localStorage.getItem('token')
  return token ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
};


const LoginRoute = () => {
  let token = localStorage.getItem('token')
  return !token ? (
    <Outlet />
  ) : (
    <Navigate to="/" />
  );
};

export  {LoginRoute, ProtectedRoutes};